import React from 'react';

export default function Transfer() {
  return <div>Transfer</div>;
}
